import { CommonUIModule } from '../webpack';
const CommonDialogDivs = Object.values(CommonUIModule).filter((m) => (typeof m === 'object' && m?.render?.toString().includes('createElement("div",{...')) || m?.render?.toString().includes('createElement("div",Object.assign({},'));
const MappedDialogDivs = new Map(Object.values(CommonDialogDivs).map((m) => {
    try {
        const renderedDiv = m.render({});
        // Take only the first class name segment as it identifies the element we want
        return [renderedDiv.props.className.split(' ')[0], m];
    }
    catch (e) {
        console.error('[DFL:Dialog]: failed to render common dialog component', e);
        return [null, null];
    }
}));
/** @component React Components */
export const DialogHeader = (MappedDialogDivs.get('DialogHeader') ||
    Object.values(CommonUIModule).find((component) => {
        const str = component?.render?.toString?.();
        return str?.includes('role:"heading"') && str.includes(')("DialogHeader",');
    }));
/** @component React Components */
export const DialogSubHeader = MappedDialogDivs.get('DialogSubHeader');
/** @component React Components */
export const DialogFooter = MappedDialogDivs.get('DialogFooter');
/** @component React Components */
export const DialogLabel = MappedDialogDivs.get('DialogLabel');
/** @component React Components */
export const DialogBodyText = MappedDialogDivs.get('DialogBodyText');
/** @component React Components */
export const DialogBody = MappedDialogDivs.get('DialogBody');
/** @component React Components */
export const DialogControlsSection = MappedDialogDivs.get('DialogControlsSection');
/** @component React Components */
export const DialogControlsSectionHeader = MappedDialogDivs.get('DialogControlsSectionHeader');
/** @component React Components */
export const DialogButtonPrimary = Object.values(CommonUIModule).find((mod) => mod?.render?.toString()?.includes('"DialogButton","_DialogLayout","Primary"'));
/** @component React Components */
export const DialogButtonSecondary = Object.values(CommonUIModule).find((mod) => mod?.render?.toString()?.includes('"DialogButton","_DialogLayout","Secondary"'));
/** @component React Components */
export const DialogButton = DialogButtonSecondary;
